"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _index2 = _interopRequireDefault(require("../../../../components/ActivationCode/index.vue"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _hike = require("@/api/hike");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "HikeMain",
  components: {
    HikeGeninfo: _index.HikeGeninfo,
    HikeStaff: _index.HikeStaff,
    HikeResource: _index.HikeResource,
    HikeCode: _index.HikeCode,
    HikeStage: _index.HikeStage,
    HikeParticipant: _index.HikeParticipant,
    HikeReport: _index.HikeReport,
    HikeSurvey: _index.HikeSurvey,
    ActivationCode: _index2.default,
    HikeEmailSetting: _index.HikeEmailSetting
  },
  props: {
    displayType: {
      type: String,
      default: "create"
    }
  },
  data() {
    return {
      fullscreenloading: false,
      recordStatus: "",
      flagRemindSave: false,
      hikeForm: {
        id: "",
        category: "",
        skillCompassDimensions: "auto",
        // For new create hike, use new 16+4 skill compass.
        title: "",
        publish: "",
        channel: "vilt",
        rubricId: "",
        pid: "",
        webinarName: "",
        webinarKey: "",
        webinarPasscode: "",
        estimatedParticipantCount: 0,
        start: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        end: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        // expiry: { utc: '', timezone: moment.tz.guess(), local: '' },   // no use
        address: {
          address1: "",
          address2: "",
          city: "",
          region: "",
          postalCode: "",
          country: ""
        },
        // locale: 'en',  no use
        description: "",
        resources: [],
        stages: [],
        tags: [],
        staff: [],
        isFeedbackEnabled: true,
        isPostProgramFeedbackEnabled: false,
        postProgramFeedbackSurveyLandingPageUrl: null,
        feedbackUrl: "",
        report: {},
        tempInternalTitle: "",
        internal: {
          title: "",
          opportunityNumber: "",
          clientName: "",
          remark: ""
        },
        metadata: {
          tenant: ""
        },
        ratingMethod: "by_assignment",
        emailRuleSet: "",
        automatedEmail: [],
        zoomUrl: "",
        orientationUrl: "",
        trailGuideUrl: "",
        loopScheduleViewUrl: "",
        createdAt: "",
        updatedAt: ""
      },
      oldClientPocList: [],
      relatedLoops: [],
      relatedLoopsLoading: false
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(["email"])
  },
  created() {
    if (this.displayType === "edit") {
      const id = typeof this.$route.params.id === "undefined" ? this.hikeForm.id : this.$route.params.id;
      this.recordStatus = "edit";
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getHike(id, false); // copy mode is false
    } else if (this.displayType === "createfromcopy") {
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getHike(this.fromId, true);
    } else {
      // create from new
      this.recordStatus = "create";
    }
  },
  watch: {
    'hikeForm.category'(val) {
      if (val === 'manager') {
        if (!this.hikeForm.survey) {
          this.$set(this.hikeForm, 'survey', {
            benchmarkSelfAssessment: '',
            benchmarkBoss: '',
            benchmarkPeer: '',
            benchmarkDirectReport: '',
            summitSelfAssessment: '',
            summitBoss: '',
            summitPeer: '',
            summitDirectReport: '',
            start: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            end: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            summitStart: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            summitEnd: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            reminderSetting: {
              benchmark: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              },
              summit: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              }
            }
          });
        }
      }
    }
  },
  methods: {
    showReportTab() {
      if (this.hikeForm.skillCompassDimensions === "auto") {
        return true;
      }
      return false;
    },
    async doCreate(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      this.hikeForm.publish = publishStatus;
      this.hikeForm.internal.title = this.hikeForm.tempInternalTitle;

      // validate
      if (this.hikeForm.metadata.tenant === "") {
        this.fullscreenloading = false;
        const msg = "Please select the tenant";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.category === "") {
        this.fullscreenloading = false;
        const msg = "Please select the category";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.title === "") {
        this.fullscreenloading = false;
        const msg = "Title is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.start.utc === "" || this.hikeForm.end.utc === "") {
        this.fullscreenloading = false;
        const msg = "Hike event time is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      const startDate = new Date(this.hikeForm.start.utc);
      const endDate = new Date(this.hikeForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = "Start-Time is later than End-Time in Hike event time";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.start.timezone === "" || this.hikeForm.end.timezone === "") {
        this.fullscreenloading = false;
        const msg = "Timezone is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      var stageLength = typeof this.hikeForm.stages === "undefined" ? 0 : this.hikeForm.stages.length;
      if (stageLength > 0) {
        /*
        if (!( this.hikeForm.stages[0].type === 'benchmark' && this.hikeForm.stages[stageLength-1].type === 'summit' )){
          this.fullscreenloading = false
          const msg = 'Stage setting has something wrong. Please make sure the first stage is Benchmark and the last stage is Summit'
          displayPopupMessage(msg, 'error')
          return
        }
        */

        if (!this.hikeForm.stages[0].taskSortDay && this.hikeForm.stages[0].type === "benchmark" && this.hikeForm.publish !== "draft") {
          this.fullscreenloading = false;
          const msg = "Missing rating deadline setting. Please make sure it has value in benchmark";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (!this.hikeForm.stages[stageLength - 1].taskSortDay && this.hikeForm.stages[stageLength - 1].type === "summit" && this.hikeForm.publish !== "draft") {
          this.fullscreenloading = false;
          const msg = "Missing rating deadline setting. Please make sure it has value in summit";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (!(this.hikeForm.stages[0].type === "benchmark" && this.hikeForm.stages[stageLength - 1].type === "summit")) {
          var ret = await this.$confirm("The structure of Hike is incomplete, Continue?", "Warning", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }).then(() => {
            return true;
          }).catch(() => {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Please make sure the Hike structure is benchmark + stage(s) + summit", "error");
            return false;
          });
          if (!ret) return;
        }
        for (let stageIndex in this.hikeForm.stages) {
          if ((this.hikeForm.stages[stageIndex].start.utc === "" || this.hikeForm.stages[stageIndex].end.utc === "") && this.hikeForm.publish !== "draft") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Event time is missing in Stage " + (1 * stageIndex + 1), "error");
            return;
          }
          const startDate = new Date(this.hikeForm.stages[stageIndex].start.utc);
          const endDate = new Date(this.hikeForm.stages[stageIndex].end.utc);
          if (startDate > endDate && this.hikeForm.publish !== "draft") {
            this.fullscreenloading = false;
            const msg = `Start-Time is later than End-Time in Stage ` + (1 * stageIndex + 1) + " event time";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          for (const actionSetIndex in this.hikeForm.stages[stageIndex].actionSets) {
            const actionSet = this.hikeForm.stages[stageIndex].actionSets[actionSetIndex];
            const type = actionSet.type;
            if (type === "benchmark" && this.hikeForm.publish !== "draft") {
              let raterCount = actionSet.raterCount;
              if (raterCount === undefined) {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("RaterCount is missing in Stage " + (1 * stageIndex + 1) + ", Activity " + (1 * actionSetIndex + 1), "error");
                return;
              }
            }
            if (type === "summit" && this.hikeForm.publish !== "draft") {
              let raterCount = actionSet.raterCount;
              if (raterCount === undefined) {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("RaterCount is missing in Stage " + (1 * stageIndex + 1) + ", Activity " + (1 * actionSetIndex + 2), "error");
                return;
              }
            }
          }
        }
        //}
      }
      if (this.hikeForm.category === 'manager') {
        if (this.hikeForm.survey.benchmarkSelfAssessment || this.hikeForm.survey.benchmarkBoss || this.hikeForm.survey.benchmarkPeer || this.hikeForm.survey.benchmarkDirectReport || this.hikeForm.survey.summitSelfAssessment || this.hikeForm.survey.summitBoss || this.hikeForm.survey.summitPeer || this.hikeForm.survey.summitDirectReport) {
          if (!this.hikeForm.survey.benchmarkSelfAssessment) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Self Assessment Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkBoss) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Boss Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkPeer) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Peer Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkDirectReport) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Direct Report Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitSelfAssessment) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Self Assessment Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitBoss) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Boss Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitPeer) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Peer Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitDirectReport) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Direct Report Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
        }
        if (this.hikeForm.survey.start.utc === "" || this.hikeForm.survey.end.utc === "") {
          this.fullscreenloading = false;
          const msg = "Benchmark effective date is missing";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        const benchmarkStartDate = new Date(this.hikeForm.survey.start.utc);
        const benchmarkEndDate = new Date(this.hikeForm.survey.end.utc);
        if (benchmarkStartDate > benchmarkEndDate) {
          this.fullscreenloading = false;
          const msg = "Start-Time is later than End-Time in Benchmark effective date";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (this.hikeForm.survey.summitStart.utc === "" || this.hikeForm.survey.summitEnd.utc === "") {
          this.fullscreenloading = false;
          const msg = "Summit effective date is missing";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        const summitStartDate = new Date(this.hikeForm.survey.summitStart.utc);
        const summitEndDate = new Date(this.hikeForm.survey.summitEnd.utc);
        if (summitStartDate > summitEndDate) {
          this.fullscreenloading = false;
          const msg = "Start-Time is later than End-Time in Summit effective date";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
      }
      //fixed bug LHVO4121
      //Admin Portal - Hike - The resources ID will auto-disappear after copying and saving the Hike
      // remove stage resource is empty value
      for (var i = 0; i < this.checkArrayLength(this.hikeForm.stages); i++) {
        if (this.hikeForm.stages[i].replayResource === "" || this.hikeForm.stages[i].replayResource === null) {
          this.hikeForm.stages[i].replayResource = undefined;
        }
        for (var j = 0; j < this.checkArrayLength(this.hikeForm.stages[i].actionSets); j++) {
          for (var k = 0; k < this.checkArrayLength(this.hikeForm.stages[i].actionSets[j].actions); k++) {
            if (this.hikeForm.stages[i].actionSets[j].actions[k].type === "resource") {
              const resource = this.hikeForm.stages[i].actionSets[j].actions[k].resource;
              if (typeof resource === "object") {
                var resId = resource ? resource.id : null;
                console.info("submit before Resource object:");
                console.info("stage" + i + " actionSets" + j + " actions" + k + " resID=" + resId);
                console.info(resource);
                this.hikeForm.stages[i].actionSets[j].actions[k].resource = resId;
                console.info("submit after Resource object:");
                console.info(this.hikeForm.stages[i].actionSets[j].actions[k].resource);
                console.info("---------------------------------");
              } else {
                var resId = resource ? resource : null;
                console.info("submit before Resource string:");
                console.info("stage" + i + " actionSets" + j + " actions" + k + " resID=" + resId);
                console.info(resource);
                this.hikeForm.stages[i].actionSets[j].actions[k].resource = resId;
                console.info("submit after Resource string:");
                console.info(this.hikeForm.stages[i].actionSets[j].actions[k].resource);
                console.info("---------------------------------");
              }
            }
          }
        }
      }

      // Reset Id to '' if copy
      if (this.hikeForm.id === "copy") {
        this.hikeForm.id = "";
      }

      // submit
      if (this.hikeForm.id === "") {
        // If category is not 'manager', do not send 'survey' data
        if (this.hikeForm.category !== 'manager') {
          delete this.hikeForm.survey;
        }
        // console.info('submit hikeForm:')
        // console.info(JSON.stringify(this.hikeForm))
        let data = _lodash.default.cloneDeep(this.hikeForm);
        data.isFeedbackEnabled = this.hikeForm.isFeedbackEnabled;
        data.isPostProgramFeedbackEnabled = this.hikeForm.isPostProgramFeedbackEnabled;
        delete data.createdAt;
        delete data.updatedAt;
        (0, _hike.createHike)(token, data).then(response => {
          (0, _log.showDebugLog)("Hike-create-response1", response);
          this.fullscreenloading = false;
          this.hikeForm.id = response.data.id;
          this.hikeForm.publish = response.data.publish;

          // console.log('Success create', this.displayType)
          let msg = `${response.data.title} (${response.data.id}) is created.`;
          const coachTools = this.$store.getters.coachTools;
          const availableRateJobDays = coachTools.availableRateJobDays;
          console.info('coachTools');
          console.info(availableRateJobDays);
          const localDate = (0, _momentTimezone.default)().subtract(availableRateJobDays, 'd');
          const localUTCDate = _momentTimezone.default.parseZone(localDate).utc();
          console.info(localDate.format());
          console.info(localUTCDate.format());
          console.info('start.utc');
          console.info(this.hikeForm.start.utc);
          if (localUTCDate.isAfter(this.hikeForm.start.utc)) {
            //console.info('开始日期小于本utc时间')
            msg = `This Hike started over ${availableRateJobDays} days ago. Certain functions will not work, including Benchmark/Summit ratings.`;
            (0, _log.displayPopupMessage)(msg, "warning", 0);
          } else {
            //console.info('开始日期大于本utc时间')
            (0, _log.displayPopupMessage)(msg, "success");
          }
          if (this.hikeForm.category === 'manager') {
            this.$refs.hikeSurvey.resetSurveyFormChangedStatus();
          }
          this.hikeForm.isFeedbackEnabled = response.data.isFeedbackEnabled;
          this.hikeForm.isPostProgramFeedbackEnabled = response.data.isPostProgramFeedbackEnabled;
          this.hikeForm.postProgramFeedbackSurveyLandingPageUrl = response.data.postProgramFeedbackSurveyLandingPageUrl;
          // this.isCreatedRecord = true

          (0, _ga.writeGaEvent)(this, "Hike", `${_lifehikesInitData.userEvent.hike.create}`, oEmail, `Hike Id: ${this.hikeForm.id}`);
          var keys_to_keep = ["role", "user"];
          const result = this.hikeForm.staff.map(e => {
            const obj = {};
            keys_to_keep.forEach(k => obj[k] = e[k]);
            return obj;
          });
          (0, _ga.writeGaEvent)(this, "Hike", `${_lifehikesInitData.userEvent.hike.create}`, oEmail, `Staff: ${JSON.stringify(result)}`);
          if (this.displayType === "createfromcopy" || this.displayType === "create") {
            this.$router.push(`/hike/edit/${response.data.id}`);
          }
        }).catch(error => {
          (0, _log.showDebugLog)("hike-create-error", error);
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)(error, "error");
        });
      }
    },
    async doSave(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      const id = typeof this.$route.params.id === "undefined" ? this.hikeForm.id : this.$route.params.id;
      this.hikeForm.publish = publishStatus;
      this.hikeForm.internal.title = this.hikeForm.tempInternalTitle + "";

      // validate
      if (this.hikeForm.metadata.tenant === "") {
        this.fullscreenloading = false;
        const msg = "Please select the tenant";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.category === "") {
        this.fullscreenloading = false;
        const msg = "Please select the category";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.orientationUrl !== '' && !/^https?:\/\//i.test(this.hikeForm.orientationUrl)) {
        this.fullscreenloading = false;
        const msg = `Please input valid URL format in Session Zero Link.`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.trailGuideUrl !== '' && !/^https?:\/\//i.test(this.hikeForm.trailGuideUrl)) {
        this.fullscreenloading = false;
        const msg = `Please input valid URL format in Trail Guide Link.`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.loopScheduleViewUrl !== '' && !/^https?:\/\//i.test(this.hikeForm.loopScheduleViewUrl)) {
        this.fullscreenloading = false;
        const msg = `Please input valid URL format in Loop Schedule View Link.`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.zoomUrl !== '' && !/^https?:\/\//i.test(this.hikeForm.zoomUrl)) {
        this.fullscreenloading = false;
        const msg = `Please input valid URL format in Zoom Invite Link.`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.start.utc === "" || this.hikeForm.end.utc === "") {
        this.fullscreenloading = false;
        const msg = `Hike event time is missing`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      const startDate = new Date(this.hikeForm.start.utc);
      const endDate = new Date(this.hikeForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = "Start-Time is later than End-Time in Hike event time";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.hikeForm.title === "") {
        this.fullscreenloading = false;
        const msg = `Hike's title is missing`;
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }

      //if (this.hikeForm.publish !== "draft") {
      // if (this.hikeForm.category === "") {
      //   this.fullscreenloading = false;
      //   const msg = `Hike's category is missing`;
      //   displayPopupMessage(msg, "error");
      //   return;
      // }

      // check first stage must be benchmark and last stage must be submit
      var stageLength = typeof this.hikeForm.stages === "undefined" ? 0 : this.hikeForm.stages.length;
      if (stageLength > 0) {
        const benchmarkCount = this.hikeForm.stages.filter(element => element.type === "benchmark").length;
        const summitCount = this.hikeForm.stages.filter(element => element.type === "summit").length;
        if (benchmarkCount > 1) {
          this.fullscreenloading = false;
          const msg = "Stage setting has something wrong. Please make sure only one stage is Benchmark.";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (summitCount > 1) {
          this.fullscreenloading = false;
          const msg = "Stage setting has something wrong. Please make sure only one stage is Summit.";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }

        // check benchmark stage and summit sequence -- fix LHVO-1844
        if (benchmarkCount == 1 && stageLength > 1 && this.hikeForm.stages[0].type !== "benchmark") {
          this.fullscreenloading = false;
          const msg = "Stage setting has something wrong. Please make sure the first stage is Benchmark";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (summitCount == 1 && stageLength > 1 && this.hikeForm.stages[stageLength - 1].type !== "summit") {
          this.fullscreenloading = false;
          const msg = "Stage setting has something wrong. Please make sure the last stage is Summit.";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }

        /*
        if (!(this.hikeForm.stages[0].type === 'benchmark' && this.hikeForm.stages[stageLength - 1].type === 'summit')) {
          this.fullscreenloading = false
          const msg = 'Stage setting has something wrong. Please make sure the first stage is Benchmark and the last stage is Summit'
          displayPopupMessage(msg, 'error')
          return
        }
          // check first stage (benchmark) and last stage (summit) must have deadline day
        if ((!this.hikeForm.stages[0].taskSortDay  || !this.hikeForm.stages[stageLength - 1].taskSortDay)) {
          this.fullscreenloading = false
          const msg = 'Missing rating deadline setting. Please make sure it has value in benchmark and summit stage'
          displayPopupMessage(msg, 'error')
          return
        }
        */

        if (!this.hikeForm.stages[0].taskSortDay && this.hikeForm.stages[0].type === "benchmark" && this.hikeForm.publish !== "draft") {
          this.fullscreenloading = false;
          const msg = "Missing rating deadline setting. Please make sure it has value in benchmark";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (!this.hikeForm.stages[stageLength - 1].taskSortDay && this.hikeForm.stages[stageLength - 1].type === "summit" && this.hikeForm.publish !== "draft") {
          this.fullscreenloading = false;
          const msg = "Missing rating deadline setting. Please make sure it has value in summit";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (!(this.hikeForm.stages[0].type === "benchmark" && this.hikeForm.stages[stageLength - 1].type === "summit")) {
          var ret = await this.$confirm("The structure of Hike is incomplete, Continue?", "Warning", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }).then(() => {
            return true;
          }).catch(() => {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Please make sure the Hike structure is benchmark + stage(s) + summit", "error");
            return false;
          });
          if (!ret) return;
        }

        // also make sure the stages have correct actionSets
        const stageActionSetTypes = {};
        stageActionSetTypes["stage"] = ["bunny", "diamond", "info", "moment", "bonus"];
        stageActionSetTypes["benchmark"] = ["bunny", "diamond", "moment", "benchmark", "benchmarkreport", "bonus"];
        stageActionSetTypes["summit"] = ["summit", "moment", "summitreport"];
        let sidx = 0;
        for (const stage of this.hikeForm.stages) {
          sidx++;
          // Check actionSet
          const actionSetTypes = stageActionSetTypes[stage.type];
          for (const actionSet of stage.actionSets) {
            if (!actionSetTypes.includes(actionSet.type)) {
              this.fullscreenloading = false;
              const msg = "Stage " + sidx + ":[" + stage.type + "] should not include activity: [" + actionSet.type + ']. Please go to "Stage" -> "Activity Setting page" to update the settings';
              (0, _log.displayPopupMessage)(msg, "error");
              return;
            }
          }
        }
        for (let stageIndex in this.hikeForm.stages) {
          if ((this.hikeForm.stages[stageIndex].start.utc === "" || this.hikeForm.stages[stageIndex].end.utc === "") && this.hikeForm.publish !== "draft") {
            this.fullscreenloading = false;
            (0, _log.displayPopupMessage)("Event time is missing in Stage " + (1 * stageIndex + 1), "error");
            return;
          }
          const startDate = new Date(this.hikeForm.stages[stageIndex].start.utc);
          const endDate = new Date(this.hikeForm.stages[stageIndex].end.utc);
          if (startDate > endDate && this.hikeForm.publish !== "draft") {
            this.fullscreenloading = false;
            const msg = `Start-Time is later than End-Time in Stage ` + (1 * stageIndex + 1) + " event time";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
        }
      }

      // Check hike.report values
      if (this.hikeForm.report) {
        let errMsg = false;
        let scoreConfig = this.hikeForm.report.scoreConfig;
        let skillGroup = this.hikeForm.report.skillGroup;
        if (scoreConfig) {
          if (scoreConfig.overall) {
            for (let tmp of scoreConfig.overall) {
              if (tmp["title"] === "" || tmp["title"] === undefined || tmp["weight"] === undefined) {
                errMsg = true;
                break;
              }
            }
          }
          if (scoreConfig.video) {
            for (let tmp of scoreConfig.video) {
              if (tmp["title"] === "" || tmp["title"] === undefined) {
                errMsg = true;
                break;
              }
            }
          }
        }
        if (skillGroup) {
          if (skillGroup.groups) {
            for (let tmp of skillGroup.groups) {
              if (tmp["title"] === "" || tmp["title"] === undefined) {
                errMsg = true;
                break;
              }
              for (let skill of tmp.skills) {
                if (skill["title"] === "" || skill["avgScore"] === undefined) {
                  errMsg = true;
                  break;
                }
              }
            }
          }
        }
        if (this.hikeForm.report.mostActiveHikersMaxCount === undefined) {
          errMsg = true;
        }
        if (this.hikeForm.report.mostActiveHikersMaxCount === undefined) {
          errMsg = true;
        }
        if (errMsg) {
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Please check "Report" section', "error");
          return;
        }
      }

      // remove stage resource is empty value
      for (var i = 0; i < this.hikeForm.stages.length; i++) {
        if (this.hikeForm.stages[i].replayResource === "" || this.hikeForm.stages[i].replayResource === null) {
          this.hikeForm.stages[i].replayResource = undefined;
        }
      }
      for (let stageIndex in this.hikeForm.stages) {
        for (let actionSetIdnex in this.hikeForm.stages[stageIndex].actionSets) {
          if (this.hikeForm.report) {
            if (this.hikeForm.report.show720SurveyData === true) {
              console.info('stage' + stageIndex + '的enable720Survey：' + this.hikeForm.stages[stageIndex].enable720Survey);
              const type = this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].type;
              const enable720Survey = this.hikeForm.stages[stageIndex].enable720Survey;
              console.info('stage' + stageIndex + '的enable720Survey：' + enable720Survey);
              console.info('actionSets' + actionSetIdnex + '的type：' + type);
              console.info(enable720Survey !== true && (type === 'benchmark' || type == 'summit'));
              if (enable720Survey !== true && (type === 'benchmark' || type == 'summit')) {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("You cannot show 720 Team Survey Data in report because the “Enable 720 Survey” is disabled in benchmark and / or summit activity. Please check it.", "error");
                return;
              }
            }
          }
          for (let actionIndex in this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions) {
            if (this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type === "skill") {
              let skillId = this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].skill;
              if (skillId === undefined || skillId === null || skillId === "") {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Skill Id is missing in Stage " + (1 * stageIndex + 1) + " Activity " + (1 * actionSetIdnex + 1) + " Component " + (1 * actionIndex + 1) + ". \nPlease add it before saving activity.", "error");
                return;
              }
            }
            if (this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type === "resource") {
              let resource = this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource;
              if (resource === undefined || resource === null) {
                this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Resource Id is missing in Stage " + (1 * stageIndex + 1) + " Activity " + (1 * actionSetIdnex + 1) + " Component " + (1 * actionIndex + 1) + ". \nPlease add it before saving activity.", "error");
                return;
              } else {
                let id = resource.id;
                if (id === undefined || resource === null) {
                  this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource = resource;
                } else {
                  this.hikeForm.stages[stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource = resource.id;
                }
              }
            }
          }
        }
      }
      if (this.hikeForm.category === 'manager') {
        if (this.hikeForm.survey.benchmarkSelfAssessment || this.hikeForm.survey.benchmarkBoss || this.hikeForm.survey.benchmarkPeer || this.hikeForm.survey.benchmarkDirectReport || this.hikeForm.survey.summitSelfAssessment || this.hikeForm.survey.summitBoss || this.hikeForm.survey.summitPeer || this.hikeForm.survey.summitDirectReport) {
          if (!this.hikeForm.survey.benchmarkSelfAssessment) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Self Assessment Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkBoss) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Boss Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkPeer) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Peer Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.benchmarkDirectReport) {
            this.fullscreenloading = false;
            const msg = "Please select Benchmark Direct Report Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitSelfAssessment) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Self Assessment Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitBoss) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Boss Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitPeer) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Peer Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
          if (!this.hikeForm.survey.summitDirectReport) {
            this.fullscreenloading = false;
            const msg = "Please select Summit Direct Report Survey";
            (0, _log.displayPopupMessage)(msg, "error");
            return;
          }
        }
        if (this.hikeForm.survey.start.utc === "" || this.hikeForm.survey.end.utc === "") {
          this.fullscreenloading = false;
          const msg = "Benchmark effective date is missing";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        const benchmarkStartDate = new Date(this.hikeForm.survey.start.utc);
        const benchmarkEndDate = new Date(this.hikeForm.survey.end.utc);
        if (benchmarkStartDate > benchmarkEndDate) {
          this.fullscreenloading = false;
          const msg = "Start-Time is later than End-Time in Benchmark effective date";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        if (this.hikeForm.survey.summitStart.utc === "" || this.hikeForm.survey.summitEnd.utc === "") {
          this.fullscreenloading = false;
          const msg = "Summit effective date is missing";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        const summitStartDate = new Date(this.hikeForm.survey.summitStart.utc);
        const summitEndDate = new Date(this.hikeForm.survey.summitEnd.utc);
        if (summitStartDate > summitEndDate) {
          this.fullscreenloading = false;
          const msg = "Start-Time is later than End-Time in Summit effective date";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
      }

      // If category is not 'manager', do not send 'survey' data
      if (this.hikeForm.category !== 'manager') {
        delete this.hikeForm.survey;
      }

      // if (this.hikeForm.report)
      // {
      //   if (this.hikeForm.report.show720SurveyData === true) {
      //     this.hikeForm.stages.forEach(stage => {
      //       stage.actionSets.forEach(action =>action.type.includes('benchmark','summit'))
      //     })
      //   }
      // }
      // submit
      (0, _log.showDebugLog)("Save Form", this.hikeForm);
      (0, _hike.updateHikeById)(token, id, this.hikeForm).then(response => {
        (0, _log.showDebugLog)("Hike-update-response", response);
        this.fullscreenloading = false;
        this.hikeForm.id = response.data.id;
        this.hikeForm.publish = response.data.publish;
        this.hikeForm.staff = response.data.staff;
        this.hikeForm.updatedAt = response.data.updatedAt;
        this.hikeForm.isFeedbackEnabled = response.data.isFeedbackEnabled;
        this.hikeForm.isPostProgramFeedbackEnabled = response.data.isPostProgramFeedbackEnabled;
        this.hikeForm.postProgramFeedbackSurveyLandingPageUrl = response.data.postProgramFeedbackSurveyLandingPageUrl;
        const clientPocList = this.hikeForm.staff.filter(row => row.role === 'client-poc');
        this.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
        let msg = `${response.data.title} (${response.data.id}) is updated.`;
        const coachTools = this.$store.getters.coachTools;
        const availableRateJobDays = coachTools.availableRateJobDays;
        console.info('coachTools');
        console.info(availableRateJobDays);
        const localDate = (0, _momentTimezone.default)().subtract(availableRateJobDays, 'd');
        const localUTCDate = _momentTimezone.default.parseZone(localDate).utc();
        console.info(localDate.format());
        console.info(localUTCDate.format());
        console.info('start.utc');
        console.info(this.hikeForm.start.utc);
        if (localUTCDate.isAfter(this.hikeForm.start.utc)) {
          //console.info('开始日期小于本utc时间')
          msg = `This Hike started over ${availableRateJobDays} days ago. Certain functions will not work, including Benchmark/Summit ratings.`;
          (0, _log.displayPopupMessage)(msg, "warning", 0);
        } else {
          //console.info('开始日期大于本utc时间')
          (0, _log.displayPopupMessage)(msg, "success");
        }
        if (this.$refs.hikeStaff) {
          this.$refs.hikeStaff.getStaffList();
        }
        if (this.hikeForm.category === 'manager') {
          this.$refs.hikeSurvey.resetSurveyFormChangedStatus();
        }
        (0, _ga.writeGaEvent)(this, "Hike", `${_lifehikesInitData.userEvent.hike.edit}`, oEmail, `Edit in Hike Main - Hike Id: ${this.hikeForm.id}`);
        (0, _ga.writeGaEvent)(this, "Hike", `${_lifehikesInitData.userEvent.hike.edit}`, this.email, `avoid undefined email, Edit in Hike Main - Hike Id: ${this.hikeForm.id}`);
        var keys_to_keep = ["role", "user"];
        const result = this.hikeForm.staff.map(e => {
          const obj = {};
          keys_to_keep.forEach(k => obj[k] = e[k]);
          return obj;
        });
        (0, _ga.writeGaEvent)(this, "Hike", `${_lifehikesInitData.userEvent.hike.edit}`, oEmail, `Staff: ${JSON.stringify(result)}`);
      }).catch(error => {
        (0, _log.showDebugLog)("Hike-update-error", error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });

      // this.flagRemindSave = (this.hikeForm.stages[0].taskSortDay)? false : true
    },
    getHike(id, isCopy) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.fullscreenloading = true;
      (0, _hike.getHikeById)(token, id).then(response => {
        const d = response.data;
        // check error and return immediate
        if (typeof d.id === "undefined") {
          this.fullscreenloading = false;
          const msg = "Cannot get the hike, please contact to system administrator";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        (0, _log.showDebugLog)("Hike-getHikeById-response", d);
        this.hikeForm.id = isCopy ? "copy" : d.id;

        // In-app feedback
        if (isCopy) {
          if (this.$route.query.f === "true") {
            this.hikeForm.isFeedbackEnabled = d.isFeedbackEnabled;
          } else {
            this.hikeForm.isFeedbackEnabled = true;
          }
        } else {
          this.hikeForm.isFeedbackEnabled = d.isFeedbackEnabled;
        }

        // LHVO-4824 Do not copy Post Program Feedback settings from original Hike
        if (isCopy) {
          this.hikeForm.isPostProgramFeedbackEnabled = false;
          this.hikeForm.postProgramFeedbackSurveyLandingPageUrl = null;
        } else {
          this.hikeForm.isPostProgramFeedbackEnabled = d.isPostProgramFeedbackEnabled;
          this.hikeForm.postProgramFeedbackSurveyLandingPageUrl = d.postProgramFeedbackSurveyLandingPageUrl;
        }
        // 

        this.hikeForm.ratingMethod = d.ratingMethod ? d.ratingMethod : "by_hike"; // if copy, ratingMethod finally override by backend

        // title
        if (isCopy) {
          this.hikeForm.title = this.$route.query.t === "true" ? d.title : "";
        } else {
          this.hikeForm.title = typeof d.title === "undefined" ? "" : d.title;
        }

        // internal title
        if (isCopy) {
          this.hikeForm.internal.title = this.$route.query.it === "true" ? d.internal.title : "";
        } else {
          this.hikeForm.internal.title = typeof d.title === "undefined" ? "" : d.internal.title;
        }

        // description
        if (isCopy) {
          this.hikeForm.description = this.$route.query.d === "true" ? d.description : "";
        } else {
          this.hikeForm.description = typeof d.description === "undefined" ? "" : d.description;
        }

        // rubric Id
        if (isCopy) {
          this.hikeForm.rubricId = "";
        } else {
          this.hikeForm.rubricId = d.rubricId;
        }

        // pid
        if (isCopy) {
          this.hikeForm.pid = "";
        } else {
          this.hikeForm.pid = d.pid;
        }

        // client Name
        if (isCopy) {
          this.hikeForm.internal.clientName = this.$route.query.cn === "true" ? d.internal.clientName : "";
        } else {
          this.hikeForm.internal.clientName = typeof d.internal === "undefined" ? "" : d.internal.clientName;
        }

        // resources
        if (isCopy) {
          this.hikeForm.resources = this.$route.query.r === "true" ? d.resources : [];
        } else {
          this.hikeForm.resources = typeof d.resources === "undefined" ? [] : d.resources;
        }

        // tags
        if (isCopy) {
          this.hikeForm.tags = this.$route.query.tag === "true" ? d.tags : [];
        } else {
          this.hikeForm.tags = typeof d.tags === "undefined" ? [] : d.tags;
        }

        // channel : webinar Info or Address
        if (isCopy) {
          this.hikeForm.category = this.$route.query.w === "true" ? d.category : "";
          this.hikeForm.channel = this.$route.query.w === "true" ? d.channel : "";
          this.hikeForm.webinarName = this.$route.query.w === "true" ? d.webinarName : "";
          this.hikeForm.webinarKey = this.$route.query.w === "true" ? d.webinarKey : "";
          this.hikeForm.webinarPasscode = this.$route.query.w === "true" ? d.webinarPasscode : "";
          this.hikeForm.zoomUrl = this.$route.query.w === "true" ? d.zoomUrl : "";
          if (this.$route.query.w === "true") {
            this.hikeForm.address.address1 = d.address.address1;
            this.hikeForm.address.address2 = d.address.address2;
            this.hikeForm.address.city = d.address.city;
            this.hikeForm.address.region = d.address.region;
            this.hikeForm.address.postalCode = d.address.postalCode;
            this.hikeForm.address.country = d.address.country;
          } else {
            this.hikeForm.address = {
              address1: "",
              address2: "",
              city: "",
              region: "",
              postalCode: "",
              country: ""
            };
          }
        } else {
          this.hikeForm.category = typeof d.category === "undefined" ? "" : d.category;
          this.hikeForm.channel = typeof d.channel === "undefined" ? "" : d.channel;
          this.hikeForm.webinarName = typeof d.webinarName === "undefined" ? "" : d.webinarName;
          this.hikeForm.webinarKey = typeof d.webinarKey === "undefined" ? "" : d.webinarKey;
          this.hikeForm.webinarPasscode = typeof d.webinarPasscode === "undefined" ? "" : d.webinarPasscode;
          this.hikeForm.zoomUrl = typeof d.zoomUrl === "undefined" ? "" : d.zoomUrl;
          this.hikeForm.address.address1 = typeof d.address.address1 === "undefined" ? "" : d.address.address1;
          this.hikeForm.address.address2 = typeof d.address.address2 === "undefined" ? "" : d.address.address2;
          this.hikeForm.address.city = typeof d.address.city === "undefined" ? "" : d.address.city;
          this.hikeForm.address.region = typeof d.address.region === "undefined" ? "" : d.address.region;
          this.hikeForm.address.postalCode = typeof d.address.postalCode === "undefined" ? "" : d.address.postalCode;
          this.hikeForm.address.country = typeof d.address.country === "undefined" ? "" : d.address.country;
        }

        // skillCompassDimension --> always copy from the source's hike. If cannot found the value in source, then set to 'auto'
        this.hikeForm.skillCompassDimensions = typeof d.skillCompassDimensions === "undefined" ? "auto" : d.skillCompassDimensions;

        // report
        if (isCopy) {
          if (this.$route.query.report === "true") {
            console.log("Dump report setting", d.report);
            this.hikeForm.report = typeof d.report === "undefined" ? {} : d.report;
          } else {
            this.hikeForm.report = {}; // No need to copy. just empty.
          }
        } else {
          console.log("Dump report setting", d.report);
          this.hikeForm.report = typeof d.report === "undefined" ? {} : d.report; // Load old
        }

        // remark
        this.hikeForm.internal.remark = isCopy ? "" : typeof d.internal === "undefined" ? "" : d.internal.remark;

        // feedback url
        this.hikeForm.feedbackUrl = isCopy ? "" : typeof d.feedbackUrl === "undefined" ? "" : d.feedbackUrl;

        // orientation Url
        this.hikeForm.orientationUrl = isCopy ? "" : typeof d.orientationUrl === "undefined" ? "" : d.orientationUrl;

        // trail Guide Url
        this.hikeForm.trailGuideUrl = isCopy ? "" : typeof d.trailGuideUrl === "undefined" ? "" : d.trailGuideUrl;

        // loop Schedule View Url
        this.hikeForm.loopScheduleViewUrl = isCopy ? "" : typeof d.loopScheduleViewUrl === "undefined" ? "" : d.loopScheduleViewUrl;

        // opportunityNumber
        this.hikeForm.internal.opportunityNumber = isCopy ? "" : typeof d.internal === "undefined" ? "" : d.internal.opportunityNumber;

        // metadata
        if (isCopy) {
          this.hikeForm.metadata = {
            tenant: ""
          };
        } else {
          this.hikeForm.metadata = typeof d.metadata === "undefined" ? {
            tenant: ""
          } : d.metadata;
        }

        // estimated Participant Count
        this.hikeForm.estimatedParticipantCount = isCopy ? 0 : typeof d.estimatedParticipantCount === "undefined" ? 0 : d.estimatedParticipantCount;

        // publish
        this.hikeForm.publish = isCopy ? "" : typeof d.publish === "undefined" ? "" : d.publish;

        // start date and end date
        if (isCopy) {
          if (this.$route.query.e === "true") {
            this.hikeForm.start.utc = typeof d.start.utc === "undefined" ? "" : d.start.utc;
            this.hikeForm.start.local = typeof d.start.local === "undefined" ? "" : d.start.local;
            this.hikeForm.start.timezone = typeof d.start.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.start.timezone;
            this.hikeForm.end.utc = typeof d.end.utc === "undefined" ? "" : d.end.utc; // d.end.utc.toISOString()
            this.hikeForm.end.local = typeof d.start.local === "undefined" ? "" : d.end.local;
            this.hikeForm.end.timezone = typeof d.end.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.end.timezone;
          } else {
            this.hikeForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            this.hikeForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }
        } else {
          // start date
          if (typeof d.start === "undefined") {
            this.hikeForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          } else {
            this.hikeForm.start.utc = typeof d.start.utc === "undefined" ? "" : d.start.utc;
            this.hikeForm.start.local = typeof d.start.local === "undefined" ? "" : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
            this.hikeForm.start.timezone = typeof d.start.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.start.timezone;
          }

          // end date
          if (typeof d.end === "undefined") {
            this.hikeForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          } else {
            this.hikeForm.end.utc = typeof d.end.utc === "undefined" ? "" : d.end.utc; // d.end.utc.toISOString()
            this.hikeForm.end.local = typeof d.end.local === "undefined" ? "" : d.end.local; // moment(d.start.end).tz(moment.tz.guess()).toString() // d.end.local // d.end.utc.toISOString()
            this.hikeForm.end.timezone = typeof d.end.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.end.timezone;
          }
        }

        // Hike Stage
        if (isCopy) {
          if (this.$route.query.s === "true") {
            // copy stages
            var stages = _lodash.default.cloneDeep(d.stages);
            for (var i = 0; i < stages.length; i++) {
              // remove stages id
              delete stages[i].id;
              if (this.$route.query.e === "true") {
                if (typeof stages[i].start === "undefined" || stages[i].start.utc === null) {
                  stages[i].start = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].end === "undefined" || stages[i].end.utc === null) {
                  stages[i].end = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].enableStart === "undefined" || stages[i].enableStart.utc === null) {
                  stages[i].enableStart = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].enableEnd === "undefined" || stages[i].enableEnd.utc === null) {
                  stages[i].enableEnd = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
              } else {
                stages[i].start = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].end = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].enableStart = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].enableEnd = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                if (stages[i].taskSortDay) stages[i].taskSortDay = 0;
              }

              // reassign the replayResourceID / Title
              if (typeof stages[i].replayResource === "undefined" || stages[i].replayResource === null) {
                // console.log('Main-stage-replayResource-undefined')
                stages[i].replayResource = "";
                stages[i].replayResourceTitle = "";
              } else {
                var replayResource = stages[i].replayResource;
                // console.log('Main-stage-replayResource', replayResource)
                stages[i].replayResource = typeof replayResource.id === "undefined" || replayResource.id === null ? "" : replayResource.id;
                stages[i].replayResourceTitle = typeof replayResource.title === "undefined" || replayResource.title === null ? "" : replayResource.title;
              }
            }
            this.hikeForm.stages = stages;
          } else {
            this.hikeForm.stages = [];
          }
        } else {
          // fill stages info (edit)
          // Reformat the replayResources
          for (var i = 0; i < d.stages.length; i++) {
            if (typeof d.stages[i].report === "undefined") {
              d.stages[i].report = _lodash.default.cloneDeep(_lifehikesInitData.defaultReport);
            }
            if (typeof d.stages[i].start === "undefined" || d.stages[i].start.utc === null) {
              d.stages[i].start = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].end === "undefined" || d.stages[i].end.utc === null) {
              d.stages[i].end = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].enableStart === "undefined" || d.stages[i].enableStart.utc === null) {
              d.stages[i].enableStart = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].enableEnd === "undefined" || d.stages[i].enableEnd.utc === null) {
              d.stages[i].enableEnd = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].replayResource === "undefined" || d.stages[i].replayResource === null) {
              // console.log('Main-stage-replayResource-undefined')
              d.stages[i].replayResource = "";
              d.stages[i].replayResourceTitle = "";
            } else {
              var replayResource = d.stages[i].replayResource;
              // console.log('Main-stage-replayResource', replayResource)
              d.stages[i].replayResource = typeof replayResource.id === "undefined" || replayResource.id === null ? "" : replayResource.id;
              d.stages[i].replayResourceTitle = typeof replayResource.title === "undefined" || replayResource.title === null ? "" : replayResource.title;
            }
          }
          this.hikeForm.stages = d.stages;
        }
        if (isCopy) {
          this.hikeForm.staff = [];
          // this.reportRecipients = []
          // this.teams = []
        } else {
          this.hikeForm.staff = d.staff;
          const clientPocList = this.hikeForm.staff.filter(row => row.role === 'client-poc');
          console.info('d.staff:');
          console.info(d.staff);
          console.info('clientPocList:');
          console.info(clientPocList);
          this.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
          // this.getTeam(token, d.id)
          // this.reportRecipients = []
          // this.getReportRecipients(token, d.id)
        }

        // this.flagRemindSave = (this.hikeForm.stages[0].taskSortDay)? false : true

        // hike category is 'manager'
        if (d.survey) {
          // handle old hike data that without summitStart & summitEnd
          if (!d.survey.summitStart || !d.survey.summitEnd) {
            d.survey.summitStart = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            d.survey.summitEnd = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }

          // handle old hike data that without reminderSetting
          if (!d.survey.reminderSetting) {
            d.survey.reminderSetting = {
              benchmark: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              },
              summit: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              }
            };
          }
          this.$set(this.hikeForm, 'survey', d.survey);
        }
        //Email Settings
        if (isCopy) {
          if (this.$route.query.es === "true") {
            this.hikeForm.automatedEmail = d.automatedEmail;
            this.hikeForm.emailRuleSet = d.emailRuleSet;
          } else {
            this.hikeForm.automatedEmail = [];
            this.hikeForm.emailRuleSet = _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL;
          }
        } else {
          this.hikeForm.automatedEmail = d.automatedEmail;
          this.hikeForm.emailRuleSet = d.emailRuleSet;
        }
        // To Solve internal title lagging issue, use other variable name to replace.
        this.hikeForm.tempInternalTitle = this.hikeForm.internal.title + "";
        //Clear it when category='no-rating'
        this.hikeForm.category = d.category === "no-rating" ? "" : d.category;
        //  createdAt and updatedAt
        if (isCopy) {
          this.hikeForm.createdAt = "";
          this.hikeForm.updatedAt = "";
        } else {
          this.hikeForm.createdAt = d.createdAt;
          this.hikeForm.updatedAt = d.updatedAt;
        }
        if (!isCopy) {
          const rlToken = (0, _cookie.getCookie)("ACCESS_TOKEN");
          this.relatedLoopsLoading = true;
          (0, _hike.hikeRelatedLoops)(rlToken, d.id).then(rlResponse => {
            this.relatedLoops = rlResponse.data.rows || [];
          }).catch(rlErr => {
            (0, _log.showDebugLog)("hike-hikeRelatedLoops-error", rlErr);
          }).finally(() => {
            this.relatedLoopsLoading = false;
          });
        }
        this.fullscreenloading = false;
      }).catch(error => {
        (0, _log.showDebugLog)("hike-getHikeById-error", error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    handleClick() {
      // do something later
      // auto save when change tab
    },
    updateReport(info) {
      this.hikeForm.report = info;
    },
    updateSkillCompassDimensions(info) {
      this.hikeForm.skillCompassDimensions = info + "";
    },
    updateParentStaff(staff) {
      this.hikeForm.staff = staff;
      (0, _log.showDebugLog)("Update hikeForm-staff", this.hikeForm);
    },
    updateParentResource(res) {
      (0, _log.showDebugLog)("Parent hike-Resource", res);
      this.hikeForm.resources = res;
    },
    updateParentStage(res) {
      (0, _log.showDebugLog)("Parent hike-Stage", res);
      this.hikeForm.stages = res;
    },
    updateParentGenInfo(info) {},
    checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    updateSurvey(survey) {
      this.hikeForm.survey = survey;
    },
    checkMandateFields() {
      // console.log("form", this.hikeForm.staff)
      // var producer = _.find(this.hikeForm.staff, function(s) {
      //   return s.role === "producer";
      // });
      // // console.log("producer", producer)
      // // console.log("string length", _.trim(this.hikeForm.internal.opportunityNumber).length)
      // if (
      //   typeof producer === "undefined" ||
      //   _.trim(this.hikeForm.internal.opportunityNumber).length == 0
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }

      // LHVO-5020 - Save as Publish enabled only if “SF Opportunity number” is filled
      return _lodash.default.trim(this.hikeForm.internal.opportunityNumber).length == 0 ? true : false;
    },
    updateParentEmailRuleSet(info, type) {
      (0, _log.showDebugLog)("Parent EmailRuleSet", info);
      (0, _log.showDebugLog)("Parent EmailRuleSet", type);
      if (type === "ruleSet") {
        this.hikeForm.emailRuleSet = info;
      } else {
        this.hikeForm.automatedEmail = info;
      }
    }
  }
};